import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSectorLines = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_6114_3351)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.275 -0.000191599C13.1948 0.0082459 13.1189 0.0448084 13.0613 0.101058L2.98125 10.1811C2.83781 10.3245 2.83781 10.5551 2.98125 10.6986C3.12469 10.842 3.35531 10.842 3.49875 10.6986L13.5788 0.618558C13.6955 0.510277 13.7264 0.338715 13.6561 0.196683C13.5872 0.0532461 13.4311 -0.0255041 13.275 -0.000191599ZM17.5837 4.31981C17.5303 4.33106 17.4811 4.35356 17.4375 4.38731L5.5575 12.6673C5.42953 12.7292 5.35078 12.86 5.355 13.002C5.35922 13.144 5.44641 13.2706 5.57719 13.324C5.70938 13.3789 5.85984 13.3507 5.9625 13.2523L17.8425 4.97231C17.9803 4.87668 18.0352 4.6995 17.9733 4.5434C17.9114 4.38731 17.7497 4.2945 17.5837 4.31981ZM1.89 10.7773C1.60594 10.7773 1.32047 10.8743 1.11375 11.0811L0.32625 11.8798C0.119531 12.0865 0 12.3636 0 12.6561C0 12.95 0.119531 13.2256 0.32625 13.4323L2.16 15.2661V13.3198C2.16 13.1201 2.32172 12.9598 2.52 12.9598C2.71828 12.9598 2.88 13.1201 2.88 13.3198V15.7836C2.99391 15.8243 3.11344 15.8511 3.22875 15.8511C3.41578 15.8511 3.68719 15.7864 3.96 15.5136L4.75875 14.7261C5.18625 14.2986 5.18625 13.6011 4.75875 13.1736L2.66625 11.0811C2.45953 10.8743 2.17406 10.7773 1.89 10.7773ZM2.88 15.7836C2.67328 15.7104 2.46375 15.5811 2.26125 15.3786L2.16 15.2661V16.9198H1.08V17.6398H3.96V16.9198H2.88V15.7836Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6114_3351",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgSectorLines;
